
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-youtube",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","stroke":"currentColor","fill":"transparent","class":"icon i-youtube"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 15.68l6.63-3.42L10 8.79zm2.48-11.81c5.17 0 8.59.25 8.59.25a3.53 3.53 0 012.47 1 4.33 4.33 0 011 2.44 33.68 33.68 0 01.25 4v1.87a33.68 33.68 0 01-.25 4 4.43 4.43 0 01-1 2.44 3.48 3.48 0 01-2.47 1s-3.42.26-8.59.26c-6.38-.05-8.34-.24-8.34-.24a4.17 4.17 0 01-2.71-1 4.39 4.39 0 01-1-2.44 32.46 32.46 0 01-.24-4v-1.88a32.46 32.46 0 01.24-4 4.29 4.29 0 011-2.44 3.51 3.51 0 012.46-1s3.43-.24 8.59-.24z"}})])
          )
        }
      }
    